import { render, staticRenderFns } from "./show.text-blocks.page.vue?vue&type=template&id=42c8f0f3&scoped=true&"
import script from "./show.text-blocks.page.vue?vue&type=script&lang=js&"
export * from "./show.text-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8f0f3",
  null
  
)

export default component.exports